export const GET_VENDOR_UPLOAD_REQUEST = "GET_VENDOR_UPLOAD_REQUEST";
export const GET_VENDOR_UPLOAD_SUCCESS = "GET_VENDOR_UPLOAD_SUCCESS";
export const GET_VENDOR_UPLOAD_FAILURE = "GET_VENDOR_UPLOAD_FAILURE";

export const GET_VENDOR_DATA_FOR_DOWNLOAD_REQUEST = "GET_VENDOR_DATA_FOR_DOWNLOAD_REQUEST";
export const GET_VENDOR_DATA_FOR_DOWNLOAD_SUCCESS = "GET_VENDOR_DATA_FOR_DOWNLOAD_SUCCESS";
export const GET_VENDOR_DATA_FOR_DOWNLOAD_FAILURE = "GET_VENDOR_DATA_FOR_DOWNLOAD_FAILURE";

export const UPLOADCSV_FOR_VENDOR_UPLOAD_REQUEST = "UPLOADCSV_FOR_VENDOR_UPLOAD_REQUEST";
export const UPLOADCSV_FOR_VENDOR_UPLOAD_SUCCESS = "UPLOADCSV_FOR_VENDOR_UPLOAD_SUCCESS";
export const UPLOADCSV_FOR_VENDOR_UPLOAD_FAILURE = "UPLOADCSV_FOR_VENDOR_UPLOAD_FAILURE";
